module.exports = __webpack_public_path__ + "static/img/record-zicha.aaaff72d.jpg";